import { Flex, Loader } from "@mantine/core";

export const FullPageLoader = () => {
  return (
    <Flex
      pos="fixed"
      left={0}
      top={0}
      bottom={0}
      right={0}
      display="flex"
      align="center"
      justify="center"
    >
      <Loader size="lg" />
    </Flex>
  );
};
